module.exports = __webpack_public_path__ + "img/salsa_4895.aac704da.jpg";